// extracted by mini-css-extract-plugin
module.exports = {"root":"app__root___V5OJh","dark":"app__dark___QZKiu","light":"app__light___GRhlc"};